import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appForceNumber]',
  standalone: true,
})
export class ForceNumberDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    if (!target) return;

    const value = target.value;

    if (typeof value === 'string' && value) {
      const cleanValue = value.replace(/[^0-9]/g, '');
      const numberValue = cleanValue ? Number(cleanValue) : null;

      this.ngControl.control?.setValue(numberValue, { emitEvent: false });
    }
  }

  @HostListener('blur', ['$event'])
  onBlur(event: Event): void {
    this.onInput(event);
  }
}
